import { Box, Button, Link } from "@mui/material";
import { getActiveOrganisation, useIdentity } from "contexts/identity-context";
import { useQuery } from "react-query";
import * as Routes from "routes";
import { resolveIdentityId } from "utils/identity";
import AddIcon from "@mui/icons-material/Add";
import { ReleasesTable } from "./releases-table/releases-table";
import { fetchDataReleases } from "data/queries";

export const MangeReleasePage = () => {
  const [identityState] = useIdentity();
  const isUser = !getActiveOrganisation(identityState);
  const identityId = resolveIdentityId(identityState, isUser);

  const dataReleasesQuery = useQuery(["dataReleases", identityId], () =>
    fetchDataReleases(identityState)
  );

  return (
    <Box>
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            position: "relative",
            top: "-70px",
          }}
        >
          <Button
            href={Routes.adminCreateRelease}
            LinkComponent={Link}
            startIcon={<AddIcon />}
            variant="contained"
          >
            New Release
          </Button>
        </Box>

        <Box
          style={{
            width: "100%",
            height: "100%",
            // overflow: "auto"
          }}
        >
          <ReleasesTable
            data={dataReleasesQuery?.data}
            isLoading={dataReleasesQuery.isLoading}
          />
        </Box>
      </>
    </Box>
  );
};
